export default __webpack_public_path__ + "static/media/G_Grass.38001c35.jpg";